module.exports = "https://la-static.vkplay.ru/promo/thefirst/img/rating-header-bronze.2830c69f.png";